import { Transition } from '@headlessui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { accordionClassNames } from '../../../../common';
import { ExpandButton } from '../../../../common/Buttons';
import { Row } from '../../../../common/LayoutComponents';
import {
  useSortedVersions,
  useVersionContainerControls,
} from '../../../../common/Versions';
import { RouteVersion } from '../Types';
import { RouteVersionTable } from './RouteVersionTable';

const ID = 'DraftVersionsContainer';
const HeaderId = `${ID}-Header`;

const testIds = {
  showHideButton: 'DraftVersionsContainer::showHideButton',
  versionTable: 'DraftVersionsContainer::versionTable',
};

type DraftVersionsContainerProps = {
  readonly className?: string;
  readonly routeVersions: ReadonlyArray<RouteVersion>;
};

export const DraftVersionsContainer: FC<DraftVersionsContainerProps> = ({
  className,
  routeVersions,
}) => {
  const { t } = useTranslation();

  const { expanded, setExpanded, sortingInfo, setSortingInfo } =
    useVersionContainerControls();

  const sortedRouteVersions = useSortedVersions(sortingInfo, routeVersions);

  return (
    <div className={className}>
      <Row className="justify-between">
        <h4 id={HeaderId}>{t(($) => $.versions.drafts.title)}</h4>

        <ExpandButton
          className="self-end"
          ariaControls={ID}
          expanded={expanded}
          expandedText={t(($) => $.versions.drafts.hide)}
          collapsedText={t(($) => $.versions.drafts.show)}
          onClick={() => setExpanded((p) => !p)}
          testId={testIds.showHideButton}
        />
      </Row>
      <Transition
        as="div"
        className="mt-2"
        id={ID}
        aria-labelledby={HeaderId}
        show={expanded}
        {...accordionClassNames}
      >
        <RouteVersionTable
          routeVersions={sortedRouteVersions}
          sortingInfo={sortingInfo}
          setSortingInfo={setSortingInfo}
          testId={testIds.versionTable}
          noVersionsText={t(($) => $.routeVersion.drafts.noVersions)}
        />
      </Transition>
    </div>
  );
};
